// import { HttpInterceptorFn } from '@angular/common/http';

// export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {

//   const excludedUrls = [
//     '/auth/',
//     '/api/v1/',
//     '/translate/v2'
//   ];

//   const shouldSkip = excludedUrls.some(url =>
//     req.url.includes(url)
//   );

//   // if (shouldSkip) {
//   //   return next(req);
//   // }


//   const clonedReq = req.clone({
//     withCredentials: true
//   });


//   console.log(
//     '[Credentials]',
//     req.url,
//     req.withCredentials
//   );

//   return next(clonedReq);
// };


import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

// The backend keeps separate session cookies per app and picks them by this header:
// `pms` selects accessToken / refreshToken (`market` would select the Marketplace ones).
export const CLIENT_APP_HEADER = 'X-Client-App';
export const CLIENT_APP = 'pms';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.API_URL)) {
    return next(req);
  }

  const clonedReq = req.clone({
    withCredentials: true,
    setHeaders: { [CLIENT_APP_HEADER]: CLIENT_APP }
  });

  return next(clonedReq);
};
